<template>
<div class="topbar-container">
    <div class="toggle" @click="toggleSidebar">
        <!--  <div class="collect" @click="collect">
            <img src="/imgs/daohang/r09.png" v-show="downIcon" />

            <img src="/imgs/daohang/r10.png" v-show="!downIcon" />
        </div>-->
    </div>
    <div class="topbar_t">
        <div v-if="this.default_lange =='zh_CN'">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item v-for="(item, index) in $route.meta.name" :key="index">
                    <router-link v-if="item.url" :to="item.url">{{
            item.name
          }}</router-link>
                    <a v-else>
                        {{ item.name }}
                    </a>
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <!-- 面包屑 -->
        <el-breadcrumb separator="/" v-else>
            <el-breadcrumb-item v-for="(item, index) in $route.meta.name1" :key="index">
                <router-link v-if="item.url" :to="item.url">{{
            item.name
          }}</router-link>
                <a v-else>
                    {{ item.name }}
                </a>
            </el-breadcrumb-item>
        </el-breadcrumb>
    </div>

    <div class="toggle-btn">
        <div v-if="this.default_lange =='zh_CN'">
            <p v-for="(item1) in $route.meta.lie" :key="item1.id">{{
            item1.name
          }}</p>
        </div>

        <p v-for="(item2) in $route.meta.lie1" :key="item2.id" v-else>{{
            item2.name
          }}</p>
            <p style="color:#f00">{{this.lic_exp_note}}</p>
        <div class="toggle-btn_right">
            <ul>
                <li> <span style="font-weight:550">{{this.username}}</span> {{ $t("logs.welcome") }}</li>
            </ul>
            <!-- 
        <ul>
            <li>{{ dateFormat(date) }}</li>
        </ul>-->
            <!--  <ul>
                <li @click="changeLangEvent">中文|English</li>
            </ul>-->
            <el-dropdown trigger="click" class="collect" >
                <span class="el-dropdown-link">
                    <ol>

                        <img src="/imgs/pic_user.png" />

                    </ol>
                </span>

                <el-dropdown-menu slot="dropdown" >

                    <ul class="tanchu_style" @click="out()">
                        <img src="/imgs/ic_logout.png" />

                        <el-dropdown-item command="">{{ $t("logs.out_login") }}</el-dropdown-item>

                    </ul>
<ul class="tanchu_style" @click="time_out">
                        <img src="/imgs/time_out.png" />

                        <el-dropdown-item command="" >
                           
                            {{ $t("logs.time_login") }}</el-dropdown-item>

                    </ul>
                    <ul>

                    </ul>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
    </div>
       <div class="pop-up pop-up1" v-show="tanchu"  v-drag="{ handle: '.pop_up_text_relay_domain' }">
              <!--    -->
              <div class="pop_up_text pop_up_text_relay_domain"> <span class="span_pad"></span>{{ $t("logs.time_login1") }}</div>
            
              <p></p>
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    {{ $t("logs.time_login2") }}:
                  </div>
                  <div class="block block1" style="display:flex;">
                      
                    <el-input
                      v-model="set_time"
                       style="width:25%;padding-right:6px"
                       @change="input($event)"
                       oninput="value=value.replace(/[^\d]|^0/g,'')"
                      
                    ></el-input>
                    <div style="color: #0E2C5E;font-size:14px">{{ $t("logs.time_login3") }}</div>
                  </div>
                </div>
            
              </div>

              <el-row>
                <el-button type="primary" @click="save_time_out()">{{
                  $t("tab.save")
                }}</el-button>
                <el-button type="danger" @click="tanOff()">{{
                  $t("tab.cancel")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu"></div>
</div>
</template>

<script>
import {
    mapState,
    mapActions
} from "vuex";
import BreadCrumd from "./breadcrumb";

export default {
    data() {
        return {
            lic_exp_note:"",
            set_time:JSON.parse(sessionStorage.getItem("usermsg"))? JSON.parse(sessionStorage.getItem("usermsg")).timeout:5,
            tanchu:false,
            username: '',
            date: new Date(),
            date1: new Date(),
            downIcon: true,
            pic1: "/imgs/daohang/j1.png",
            pic111: "/imgs/daohang/j2.png",
            pic11: "/imgs/daohang/j1.png",
            default_lange: ''
        };
    },

    mounted() {
        let languse = JSON.parse(sessionStorage.getItem("usermsg")) ? JSON.parse(sessionStorage.getItem("usermsg")).lang == 'en_US' ? 'en_US' : 'zh_CN' : 'zh_CN'
        this.default_lange = languse
        let username = JSON.parse(sessionStorage.getItem("usermsg")) ? JSON.parse(sessionStorage.getItem("usermsg")).USERNAME : ''
        this.username = username
        this.lic_exp_note=JSON.parse(sessionStorage.getItem("usermsg")) ? JSON.parse(sessionStorage.getItem("usermsg")).LIC_EXP_NOTE : ''

        // var _this = this; //声明一个变量指向vue实例this,保证作用域一致
        // this.timer = setInterval(function () {
        //     _this.date = new Date(); //修改数据date
        // }, 1000);
        // this.timer1 = setInterval(function () {
        //     _this.date1 = new Date(); //修改数据date
        // }, 1000);
    },
    beforeDestroy() {
        if (this.timer) {
            clearInterval(this.timer); //在vue实例销毁钱，清除我们的定时器
        }
        if (this.timer1) {
            clearInterval(this.timer1); //在vue实例销毁钱，清除我们的定时器
        }
    },

    component: {
        BreadCrumd,
    },
    computed: {
        ...mapState({
            isCollapse: (state) => state.common.isCollapse,
        }),
    },
    methods: {
        input(val){
            console.log(val)
            if(val<5){
                this.set_time=5
            }
        },
        
         //时间保存
    save_time_out() {
      // this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      let str = this.$qs.stringify({
        __mode: "save_session_timeout",
        sid: sid,
       timeout: this.set_time,
       
      });
      this.$axios
        .post("/api/adm/cgi/admin.cgi", str)
        .then((res) => {
          console.log(res);

          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
            // this.getFileList5();
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            // this.getFileList5();
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
              this.tanchu=false
            this.$message({
                type: "success",
                message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
              });
           
            // this.getFileList3()
          }
        })
       
    },
        tanOff(){
        this.tanchu=false

        },
    time_out(){
        this.tanchu=true
         this.set_time=JSON.parse(sessionStorage.getItem("usermsg"))? JSON.parse(sessionStorage.getItem("usermsg")).timeout:5;
        // this.set_time=''
    },
        // 中英文
        changeLangEvent() {

            if (this.lang === 'zh_CN') {
                this.lang = 'en_US';
                this.$i18n.locale = this.lang;
                console.log(this.$i18n.locale, '1', this.lang)

            } else {
                this.lang = 'zh_CN';
                this.$i18n.locale = this.lang;
                console.log(this.$i18n.locale, '2', this.lang)

            }
        },
        // 判断
        collect() {
            this.downIcon = !this.downIcon;
        },

        // 日期
        dateFormat(time) {
            console.log(time)
            var date = new Date(time);
            console.log(date)

            var year = date.getFullYear();

            var month =
                date.getMonth() + 1 < 10 ?
                "0" + (date.getMonth() + 1) :
                date.getMonth() + 1;
            var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
            var hours =
                date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
            var minutes =
                date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
            var seconds =
                date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
            // 拼接
            return (
                year +
                "-" +
                month +
                "-" +
                day +
                "    " +
                hours +
                ":" +
                minutes +
                ":" +
                seconds
            );
        },
        // 时间
        dateFormat1(time) {
            var date = new Date(time);
            var hours =
                date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
            var minutes =
                date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
            var seconds =
                date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
            // 拼接
            return hours + ":" + minutes + ":" + seconds;
            //
        },
        ...mapActions(["toggleSidebar"]),
        //退出登陆
        out() {
          
            // 路由传参
            sessionStorage.removeItem('usermsg')
            sessionStorage.removeItem('leftMenu')
            sessionStorage.removeItem('val')
            // judge
            sessionStorage.removeItem('judge')

            this.$router.push({
                name: "login"
            });
        },
    },
};
</script>

<style lang="less" scoped>
// 定位
.toggle {
    position: absolute;
}

// .collect {
//     img {
//         width: 20px;
//         height: 20px;
//         padding-top: 7px;
//     }
// }

.tan {
    width: 20px;
    height: 20px;
}

@import "../../css/breadcrumb.less";
@import "../../css/pou_up.less";
@import "../../css/drag.less";

</style>
